import { RootState } from '..';
import { FormScenarioType } from 'src/models/uiScenarios.model';

export const getFormUiScenario = (state: RootState) => (type: FormScenarioType) => state.uiScenarios.forms?.[type];
